let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("iLANP")).then(() => parcelRequire('eYIux'));